<template>
  <div v-if="open" class="confirm-modal-backdrop" @click.self="onClose">
    <div class="confirm-modal import-error-modal" role="dialog" aria-modal="true">
      <div class="confirm-modal-header">
        <h3>{{ title }}</h3>
        <button type="button" class="confirm-modal-close" @click="onClose" aria-label="Mbyll">&times;</button>
      </div>
      <div class="confirm-modal-body">
        <p v-if="message" class="confirm-modal-message">{{ message }}</p>
        <div v-if="errors && errors.length" class="import-error-list-wrap">
          <table class="table is-fullwidth is-narrow audit-table">
            <thead>
              <tr>
                <th v-if="hasLine">Rreshti</th>
                <th>Kodi</th>
                <th v-if="hasErp">Financa</th>
                <th>Arsyeja</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(err, i) in errors" :key="`ie-${i}-${err.code || ''}-${err.line || ''}`">
                <td v-if="hasLine">{{ err.line || "—" }}</td>
                <td>
                  <code v-if="err.code" class="sim-code">{{ err.code }}</code>
                  <span v-else>—</span>
                </td>
                <td v-if="hasErp">{{ erpLabel(err.erp) }}</td>
                <td>{{ err.reason || err.message || "—" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <pre v-else-if="payloadText" class="import-error-json">{{ payloadText }}</pre>
      </div>
      <div class="confirm-modal-actions">
        <button type="button" class="button is-light" @click="$emit('download')">Shkarko JSON</button>
        <button type="button" class="button is-primary" @click="onClose">Mbyll</button>
      </div>
    </div>
  </div>
</template>

<script>
import { financaServerLabel } from "@/utils/financaSaveNotice";

export default {
  name: "ImportErrorModal",
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: "Gabim gjatë importit" },
    message: { type: String, default: "" },
    errors: { type: Array, default: () => [] },
    payload: { type: Object, default: null },
  },
  computed: {
    hasLine() {
      return (this.errors || []).some((e) => e && e.line != null && e.line !== "");
    },
    hasErp() {
      return (this.errors || []).some((e) => e && e.erp);
    },
    payloadText() {
      if (!this.payload || (this.errors && this.errors.length)) return "";
      try {
        return JSON.stringify(this.payload, null, 2);
      } catch (_) {
        return "";
      }
    },
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    erpLabel(erp) {
      return financaServerLabel(erp);
    },
  },
};
</script>

<style scoped>
.confirm-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 81;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.confirm-modal {
  width: min(720px, 100%);
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.25);
  overflow: hidden;
}
.confirm-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px 8px;
}
.confirm-modal-header h3 {
  margin: 0;
  font-size: 1.1rem;
}
.confirm-modal-close {
  border: 0;
  background: transparent;
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
  color: #64748b;
}
.confirm-modal-body {
  padding: 8px 18px 12px;
}
.confirm-modal-message {
  margin: 0 0 10px;
  color: #334155;
  line-height: 1.45;
}
.confirm-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px 16px;
  border-top: 1px solid #e2e8f0;
}
.import-error-list-wrap {
  max-height: min(52vh, 420px);
  overflow: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.import-error-json {
  margin: 0;
  max-height: min(52vh, 420px);
  overflow: auto;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f8fafc;
  color: #334155;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-word;
}
.sim-code {
  font-size: 12px;
}
</style>
